<template>
    <div class="gwb-sign-up-city-field">
        <gwb-float-field
            :id="id"
            :name="name"
            :label="label"
            :error="error"
            :value="inputValue"
            autocomplete="off"
            @input="(event) => {
                $emit('input', event);
                addressSearch(event);
            }"
            @change="$emit('change', $event)"
            @blur="($event) => {
                  placePredictions = []
                  $emit('blur', $event);
            }"
        />
        <div v-if="placePredictions.length > 0" class="gwb-sign-up-city-field__dropdown">
            <ul class="gwb-sign-up-city-field__list">
                <li
                    v-for="place in placePredictions.slice(0, 5)"
                    :key="place.place_id"
                    class="gwb-sign-up-city-field__item"
                    @mousedown.prevent="selectPlaceDetails(place)"
                >
                    <strong v-text="place.structured_formatting.main_text"></strong>
                    <span v-text="place.structured_formatting.secondary_text"></span>
                </li>
                <li class="gwb-sign-up-city-field__copyright">Powered by Google</li>
            </ul>
        </div>
    </div>
</template>

<script>
import googleMaps from 'gwbui/src/libs/google-maps';
import {debounce as _debounce} from 'lodash';
import GwbFloatField from './gwb-float-field.vue';

export default {

    name: 'GwbSignUpCityField',

    components: {
        GwbFloatField,
    },

    props: {
        value: {
            type: String,
            default: '',
        },

        id: {
            type: String,
            default: '',
        },

        name: {
            type: String,
            default: '',
        },

        label: {
            type: String,
            default: '',
        },

        error: {
            type: Boolean,
            default: false,
        },

        country: {
            type: [Number, String],
            default: undefined,
        },
    },

    data() {
        return {
            inputValue: '',
            placePredictions: [],
        };
    },

    computed: {},

    watch: {
        value: {
            handler(val) {
                this.inputValue = val;
            },
            immediate: true,
        },
    },

    beforeCreate() {
        const language = document.documentElement.lang;
        const langRegion = {et: 'EE', lv: 'LV', lt: 'LT', de: 'DE', en: 'GB'};
        googleMaps.configLoader({
            KEY: window.gwbSrv.googleMapsApiKey,
            LANGUAGE: language,
            REGION: langRegion.hasOwnProperty(language) ? langRegion[language] : 'GB',
            LIBRARIES: ['places'],
            VERSION: 'weekly',
        });
    },

    methods: {
        returnCountryCode(countryNumb) {
            if (typeof countryNumb === 'string') {
                countryNumb = parseInt(countryNumb);
            }

            return window.gwbSrv.countryCodeMap[countryNumb];
        },
        addressSearch: _debounce(function (search) {
            this.updatePlaceDetails(null);

            if (!search) {
                this.placePredictions = [];
            } else {
                googleMaps.getPlacePredictions(search, this.returnCountryCode(this.country)).then(predictions => {
                    const allowedTypes = ['locality', 'colloquial_area', 'administrative_area_level_2'];

                    this.placePredictions = predictions
                        .filter(prediction => prediction.types.some(type => allowedTypes.indexOf(type) > -1));
                });
            }
        }, 350, {leading: true}),

        selectPlaceDetails(place) {
            googleMaps.getPlaceDetails(place.place_id).then((result) => {
                this.$emit('input', place.description);
                this.updatePlaceDetails(result);
                this.placePredictions = [];
            });
        },

        updatePlaceDetails(details) {
            const result = {
                latitude: '',
                longitude: '',
                gmdata: {},
            };

            if (details) {
                // Build gmdata object
                let gmdata = {
                    address_components: details.address_components,
                    formatted_address: details.formatted_address,
                    geometry: {
                        location: {
                            lat: details.geometry.location.lat(),
                            lng: details.geometry.location.lng()
                        }
                    },
                    name: details.name,
                    place_id: details.place_id,
                    types: details.types,
                    componentRestrictions: {country: ['EE']},
                    utc_offset: details.utc_offset_minutes,
                    vicinity: details.vicinity
                };

                // Assign needed place info to formData
                result.latitude = details.geometry.location.lat();
                result.longitude = details.geometry.location.lng();
                result.gmdata = gmdata;
            }
            this.$emit('details', result);
        },
    },

};
</script>

<style lang="scss">
.gwb-sign-up-city-field {
    &__dropdown {
        position: relative;
        top: -0.8rem;
    }

    &__list {
        position: absolute;
        // Above form fields (z 10), below the DS overlay layer (popover 10110). This block
        // is duplicated verbatim in gwb-sign-up-country-field.vue as a global selector — keep
        // the z-index identical there or bundle load-order can override this one. (GWB-673)
        z-index: 100;
        width: 100%;
        margin: 0;
        padding: 0;
        list-style: none;
        background-color: #fefefe;
        border: 1px solid #cacaca;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    }

    &__item {
        border-bottom: 1px solid #cacaca;
        padding: 0.25rem 0.5rem;
        cursor: pointer;

        &:hover {
            background-color: #e6e6e6;
        }
    }

    &__copyright {
        padding: 0.25rem 0.5rem;
        text-align: right;
        font-size: 0.5em;
    }
}
</style>
